(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["srl-loading"] && !Shopify.designMode) return;
  try {
    (function () {
    try { sessionStorage.setItem('srlIntroSeen', '1'); } catch (e) {}
    var el = document.getElementById('srl-loading');
    if (!el) return;
    el.addEventListener('animationend', function (e) {
      if (e.animationName === 'srl-loading-out' && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
